import { connect } from "react-redux";
import MaterialDelivery from "./materialDelivery";
import { bindActionCreators } from "redux";
import {
  getMaterialDelivery,
  postMaterialDelivery,
  updateStatus,
} from "services/redux/installation/materialDelivery/action";
import { getSiteInspect,getPocBySiteId,
  postSendReportMail } from "services/redux/installation/siteInspection/action";
import { generateReport } from "services/redux/installation/materialRequisition/action";
import {getSiteData, calculateDistance, getDistanceData} from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
  materialData: state.materialDeliveryReducer.materialData,
  siteData: state.siteInspectionReducer.siteData,
  pocListBySiteId: state.siteInspectionReducer.pocListBySiteId,
  userProfile : state.loginReducer.userProfile,
  siteDetails: state.leadDataReducer.siteData,
  engDistanceData: state.leadDataReducer.engDistanceData,
  distanceDetails: state.leadDataReducer.distanceDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMaterialDelivery,
      postMaterialDelivery,
      updateStatus,
      getSiteInspect,
      generateReport,
      getPocBySiteId,
      postSendReportMail,
      getSiteData,
      calculateDistance,
      getDistanceData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MaterialDelivery);
